<template>
  <div
    class="flex w-full sm:w-1/2 md:w-1/3 lg:w-1/4 content-center pl-2 py-1"
    @click="visitCategory"
  >
    <a class="card card-content card--interactive text-center">
      <div
        v-can="'manage-communication-category-membership-groups'"
        class=" -mx-6 absolute bg-grey-lighter p-1 pin-t rounded-t text-grey-dark text-xs w-full"
        v-text="visibilityText"
      />
      <div class="flex-item">
        <h3 class="mb-1">
          <a
            :href="category._links.frontend.self"
            class="no-underline"
            v-text="category.attributes.title"
          />
        </h3>
        <h5
          class="mt-0 mb-4 uppercase"
          v-text="entryCountText"
        />
        <button
          v-can="'manage-communication-category-membership-groups'"
          class="btn btn--sm btn--icon-only icon icon--small"
          @click.stop="$root.openModalWithPayload('communicationCategoryMembershipGroupModal', category)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="9"
            height="15"
            viewBox="0 0 9 15"
          >
            <path d="M7.67 2.48l.66-1.23L6.25.21 5.56 1.5zm-2.35-.54L.48 10.95l2.11.98 4.84-9.01zM.31 11.43L.1 14.11l2.21-1.75z" />
          </svg>
        </button>
      </div>
    </a>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'CommunicationCategory',
  props: {
    category: {
      type: Object,
      required: true,
    },
  },
  computed: {
    entryCountText() {
      return this.category.meta.blog_entry_count === 1
        ? '1 entry'
        : `${this.category.meta.blog_entry_count} entries`
    },
    visibilityText() {
      return this.category.membershipGroups.data.length === 1
        ? `Visible to ${this.category.membershipGroups.data.length} membership group`
        : `Visible to ${this.category.membershipGroups.data.length} membership groups`
    },
  },
  methods: {
    visitCategory() {
      window.location = this.category._links.frontend.self
    },
  },
}
</script>
